/**
 * New Data Report Route Definition (Non-Lazy)
 *
 * Def only — the guided form lives in index.lazy.tsx so its module imports
 * stay out of the entry chunk.
 */
import { createFileRoute } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_authenticated/data-reports/new/')({
  // Template-first pending while the form chunk downloads (first visit); the
  // loaded page's real title/subtitle strings so nothing swaps text on
  // arrival (the accent span collapses into the plain title here). The form
  // navigates back with an arrow and submits from the sticky BottomAction bar.
  pendingComponent: () => (
    <FormPageTemplatePending
      title="Spotted something off?"
      subtitle="Wrong data, missing listings, or a bug - tell us what happened"
      variant="arrow"
      cta
    />
  ),
});
